export default (props, vars) =>
  `You've declined your offer from\n ${vars?.['useapplicationoffer2']?.['applicationOffer'].company_name}`;
